<div class="eui-page-hero-header__logo"></div>

<div class="eui-page-hero-header__label"><strong>{{label}}</strong></div>
<div class="eui-page-hero-header__sub-label">{{subLabel}}</div>
